module.exports = __webpack_public_path__ + "img/phonepluginnockeck.2d4fd4b.svg";